/* ══════════════════════════════════════════════════════════════════════
   ADS Animations — L'Atelier des Sucres
   Scroll reveal · Sticky ATC · Cart progress update
══════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── Scroll reveal ── */
  if ('IntersectionObserver' in window) {
    var revealObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          revealObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    function initReveal() {
      document.querySelectorAll('.ads-anim-up, .ads-anim-fade').forEach(function (el) {
        revealObs.observe(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initReveal);
    } else {
      initReveal();
    }
  }

  /* ── Cart delivery bar update ──
     Les seuils ne sont plus codés en dur ici : ils dépendent du profil du client (un VDI a sa
     propre grille de frais de port, avec un seul palier de gratuité) et sont donc lus sur le
     bloc rendu par snippets/ads-mc-delivery.liquid via data-seuil-relais / data-seuil-domicile.
     Les constantes ne servent plus que de filet si les attributs manquent.
     data-seuil-relais="0", ou l'absence de seconde barre, signale le mode à seuil unique. */
  var ADS_RELAIS_DEFAUT   = 3500;  // 35,00 €
  var ADS_DOMICILE_DEFAUT = 6500;  // 65,00 €

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2 }) + ' €';
  }

  function updateDeliveryBar(total) {
    document.querySelectorAll('[data-ads-delivery]').forEach(function (wrap) {
      var bar1  = wrap.querySelector('[data-ads-bar="1"]');
      var bar2  = wrap.querySelector('[data-ads-bar="2"]');
      var msg   = wrap.querySelector('[data-ads-msg]');
      if (!bar1 || !msg) return;

      var relais   = parseInt(wrap.dataset.seuilRelais, 10);
      var domicile = parseInt(wrap.dataset.seuilDomicile, 10);
      if (isNaN(relais))   relais   = ADS_RELAIS_DEFAUT;
      if (isNaN(domicile)) domicile = ADS_DOMICILE_DEFAUT;
      if (domicile <= 0)   return;

      /* Seuil unique (VDI) : une seule barre, un seul palier de gratuité. */
      if (!bar2 || relais <= 0) {
        var pct = total >= domicile ? 100 : Math.round(total * 100 / domicile);
        bar1.style.width = pct + '%';
        if (total >= domicile) {
          bar1.className = 'ads-delivery-bar__fill ads-delivery-bar__fill--done';
          msg.innerHTML  = '🎉 Livraison offerte — merci !';
          msg.className  = 'ads-delivery-bar__msg ads-delivery-bar__msg--done';
        } else {
          bar1.className = 'ads-delivery-bar__fill';
          msg.innerHTML  = 'Plus que <strong>' + formatMoney(domicile - total) + '</strong> pour la livraison offerte';
          msg.className  = 'ads-delivery-bar__msg';
        }
        return;
      }

      var pct1 = total >= relais ? 100 : Math.round(total * 100 / relais);
      var pct2 = 0;
      if (total >= domicile) {
        pct2 = 100;
      } else if (total > relais) {
        pct2 = Math.round((total - relais) * 100 / (domicile - relais));
      }

      bar1.style.width = pct1 + '%';
      bar2.style.width = pct2 + '%';

      if (total >= domicile) {
        bar1.className = 'ads-delivery-bar__fill ads-delivery-bar__fill--done';
        bar2.className = 'ads-delivery-bar__fill ads-delivery-bar__fill--done';
        msg.innerHTML  = '🎉 Livraison à domicile offerte — merci !';
        msg.className  = 'ads-delivery-bar__msg ads-delivery-bar__msg--done';
      } else if (total >= relais) {
        bar1.className = 'ads-delivery-bar__fill ads-delivery-bar__fill--done';
        bar2.className = 'ads-delivery-bar__fill ads-delivery-bar__fill--gold';
        msg.innerHTML  = '✓ Relais offert · Plus que <strong>' + formatMoney(domicile - total) + '</strong> pour le domicile';
        msg.className  = 'ads-delivery-bar__msg';
      } else {
        bar1.className = 'ads-delivery-bar__fill';
        bar2.className = 'ads-delivery-bar__fill ads-delivery-bar__fill--gold';
        msg.innerHTML  = 'Plus que <strong>' + formatMoney(relais - total) + '</strong> pour la livraison relais offerte';
        msg.className  = 'ads-delivery-bar__msg';
      }
    });
  }

  /* Écouter les mises à jour du panier */
  document.addEventListener('cart:updated', function (e) {
    if (e.detail) {
      var total = e.detail.cart && e.detail.cart.items_subtotal_price;
      if (typeof total === 'number') updateDeliveryBar(total);
    }
  });

  /* Initialisation depuis l'attribut data */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-ads-delivery]').forEach(function (wrap) {
      var total = parseInt(wrap.dataset.cartTotal, 10) || 0;
      updateDeliveryBar(total);
    });
  });

  /* ── Sticky ATC mobile ── */
  function initStickyAtc() {
    var atc     = document.getElementById('ads-sticky-atc');
    var trigger = document.querySelector('[data-sticky-trigger]') || document.querySelector('.pdv-right');
    if (!atc || !trigger) return;

    var obs = new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      atc.classList.toggle('is-visible', !visible);
    }, { rootMargin: '-80px 0px 0px 0px' });

    obs.observe(trigger);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAtc);
  } else {
    initStickyAtc();
  }

  /* ── Variant change → sticky price update ── */
  document.addEventListener('DOMContentLoaded', function () {
    var stickyPrice = document.getElementById('ads-sticky-price');
    if (!stickyPrice) return;

    document.querySelectorAll('[data-variant-price]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var p = parseInt(btn.dataset.variantPrice, 10);
        if (p) stickyPrice.textContent = (p / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2 }) + ' €';
      });
    });
  });

})();
